export const statusCategoryIcons = {
  OPEN: "seem-icon-open",
  FIXED: "seem-icon-fixed",
  IGNORED: "seem-icon-hide",
} as const;

export const statusCategories = {
  OPEN: "OPEN",
  FIXED: "FIXED",
  IGNORED: "IGNORED",
} as const;

export const inactiveValue = 37;

export const falsePositiveValue = 31;

export const emptyAggregationGroupResolvedReason = "Aggregation group is empty";

export const emptyFindingReason = {
  EMPTY_AGG: "empty_aggregation_group",
  NOT_EXIST: "not_exist",
  INVALID_ID: "invalid_id",
  PERMISSION_DENIED: "permission_denied",
} as const;
